import { ref } from 'vue'
import axios from 'axios'
import { log } from "@/composables/useLog"
import { BASE_URL } from "@/composables/url_config"

const error = ref(null)

export const checkUsernameAvailability = async (username) => {
    log("checkUsernameAvailability called with username: " + username)
    error.value = null
    try {
        const result = await axios.post(`${BASE_URL}/home/checkUsernameAvailability`, {
            username: username
        }, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
        error.value = null
        log("checkUsernameAvailability result:")
        log(result.data)
        if (typeof result.data === 'string') {
            return JSON.parse(result.data)
        }
        return result.data
    } catch (err) {
        log("Error in checkUsernameAvailability:")
        log(err)
        error.value = "Eroare la verificarea username-ului"
        return { available: false }
    }
}

const useCheckUsernameAvailability = () => {
    return { error, checkUsernameAvailability }
}
export default useCheckUsernameAvailability
